import { useQuery, QueryFunction } from 'react-query';
import { getAllQuarries, GetQuarriesQueries, Quarry } from '../../services/apiSLTP/sites/quarries';

type UseQuarriesQueryOptions = {
    queries?: GetQuarriesQueries;
};

const getQuarries: QueryFunction<Quarry[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseQuarriesQueryOptions];
    const { queries } = options;
    try {
        const response = await getAllQuarries(queries);
        return response.data;
    } catch (error) {
        throw new Error('An unexpected error occurred while fetching quarries');
    }
};

export const useQuarriesQuery = (options: UseQuarriesQueryOptions) => {
    return useQuery(['quarries', options], getQuarries);
};
